import { render, staticRenderFns } from "./BusinessMemberPrescriptions.vue?vue&type=template&id=f41c8d74"
import script from "./BusinessMemberPrescriptions.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPrescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports